<script>
import Modal from "@/pages/components/modal.vue";
import {useForm} from "@inertiajs/vue3";
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Form from "@/pages/appointments/mixins/form";
import MultipleChecksOnly from "@/pages/components/form/input-only/multiple-checks.vue";

export default {
  mixins: [FormElements, Form],
  components: {MultipleChecksOnly, Modal},
  emits: ['update:calendar'],
  data() {
    return {
      userName: '',
      customerName: '',
      id: null,
      form: useForm({
        name: '',
        description: '',
        appointment_id: '',
        user_id: '',
        customer_id: '',
        start_date: '',
        end_date: '',
        products: [],
        available_products: [],
        default_duration: 30,
      })
    }
  },

  mounted() {
    $(document)
        .off('.select2custom2')
        .on('select2:select.select2custom2', '.customer-select2', this.setCustomerDetails.bind(this, this.form, '.start_date2'))
        .on('select2:unselect.select2custom2', '.customer-select2', this.setCustomerDetails.bind(this, this.form, '.start_date2'))

    $(document)
        .off('.easepickcustom2')
        .on('customchange.easepickcustom2', '.start_date2', this.setEndDate.bind(this, this.form));
  },

  methods: {
    open(startDate, endDate, appointment = {}, user = {}, customer = {}) {
      this.userName = user.name ?? '';
      this.customerName = customer.name ?? '';
      this.id = appointment.id ?? null;
      this.form.name = appointment.name ?? '';
      this.form.description = appointment.description ?? '';
      this.form.user_id = user.id ?? appointment.user_id ?? '';
      this.form.customer_id = customer.id ?? appointment.customer_id ?? '';
      this.form.start_date = startDate;
      this.form.end_date = endDate;
      this.form.products = appointment.products.map(product => product.id);
      this.form.available_products = this.parseProducts(customer, customer.products);
      this.form.default_duration = appointment.default_duration;
      this.$refs.modal.open();
    },

    close() {
      this.$refs.modal.close();
    },

    async destroy() {
      if (!(await Helpers.Alert.confirm('Weet je het zeker?'))) {
        return;
      }

      if (!this.id) {
        return;
      }

      $.ajax({
        method: 'DELETE',
        url: route('api.v1.appointments.delete'),
        data: {
          ids: [this.id]
        },
        success: (response) => {
          this.close();
          Helpers.Message.success('Het agenda item is verwijderd');
          this.$emit('update:calendar')
        }
      })
    },

    submit() {
      if(!this.id) {
        Helpers.Message.error('Er is iets fout gegaan.');
        return;
      }

      $.ajax({
        url: route('api.v1.appointments.update', {appointment: this.id}),
        method: 'PUT',
        data: JSON.stringify(this.form.data()),
        contentType: 'application/json',
        processData: false,
        success: () => {
          this.close();
          Helpers.Message.success('Het agenda item is aangepast.');
          this.$emit('update:calendar')
        }
      });
    }
  }
}
</script>

<template>
  <Modal ref="modal" id="updateEventModal" size="lg" title="Agenda item">
    <form id="updateForm" @submit.prevent="submit">
      <Select
          :form="form"
          v-model="form.customer_id"
          :name="`customer_id`"
          label="Klant"
          :ajaxUrl="route('api.v1.customers.list')"
          :required="true"
          class="customer-select2"
          :currentValueLabel="customerName"
      />

      <Select
          :form="form"
          v-model="form.user_id"
          :name="`user_id`"
          label="Werknemer"
          :required="true"
          :ajaxUrl="route('api.v1.users.list')"
          :currentValueLabel="userName"
      />

      <FormGroup :class="{'align-items-center': form.available_products.length < 1}">
        <template #label>Producten</template>

        <i v-if="form.available_products.length < 1">Er zijn geen producten gekoppeld aan deze klant</i>

        <MultipleChecksOnly
            v-if="form.available_products.length > 0"
            :form="form"
            v-model="form.products"
            name="products[]"
            :options="form.available_products"
            layout="vertical"
        />
      </FormGroup>

      <Input
          :form="form"
          v-model="form.name"
          :name="`name`"
          :required="true"
          label="Titel"
      />

      <DateTime
          :form="form"
          v-model="form.start_date"
          :name="`start_date`"
          :required="true"
          label="Begin"
          class="start_date2"
      />

      <DateTime
          :form="form"
          v-model="form.end_date"
          :name="`end_date`"
          :required="true"
          label="Einde"
      />

      <Textarea
          :form="form"
          v-model="form.description"
          :name="`description`"
          :required="true"
          label="Omschrijving"
      />
    </form>

    <template #footer>
      <div class="d-flex w-100 m-0 gap-1">
        <button v-if="id" class="btn btn-danger" @click.prevent="destroy">
          <i class="bi bi-trash3 m-0"></i>
        </button>

        <div class="ms-auto d-flex gap-1">
          <button class="btn btn-secondary" @click.prevent="this.close()">Annuleren</button>
          <button class="btn btn-primary" form="updateForm">Opslaan</button>
        </div>
      </div>
    </template>
  </Modal>
</template>